/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FinancierShopsGroupInstallmentOption } from './FinancierShopsGroupInstallmentOption';
export type FinancierShopGroupInstallmentConditionCreateResponse = {
    id: string;
    isOpen: boolean;
    financierShopsGroupId: string;
    name: string;
    priority: number;
    osType: FinancierShopGroupInstallmentConditionCreateResponse.osType;
    productType: FinancierShopGroupInstallmentConditionCreateResponse.productType;
    minProductPurchaseCostAmount: number;
    maxProductPurchaseCostAmount: number;
    downPaymentAmountList: Array<number>;
    installmentCountList: Array<FinancierShopsGroupInstallmentOption>;
    commissionAmount: number;
    additionalCommissionAmount: number;
    shopAgentCommissionAmount?: number;
    contractFeeAmount: number;
    unlockingFeeAmount: number;
    requiredInstallmentCount: number;
};
export namespace FinancierShopGroupInstallmentConditionCreateResponse {
    export enum osType {
        IOS = 'IOS',
        ANDROID = 'ANDROID',
        OTHERS = 'OTHERS',
    }
    export enum productType {
        ALL = 'ALL',
        NEW = 'NEW',
        USED = 'USED',
    }
}

